module.exports = __webpack_public_path__ + "media/images/flags/ye-4472dcff9e90e9995eeae8be5dc5f85c.svg";